
import React, { useState, useEffect } from "react";
import ObjectForm from "../../../../Common/ObjectForm";
import AlertDialog from "../../../../Common/AlertDialog";
import http from "../../../../Common/RestAPIHandler"
import useStyles from "../../../../Common/Style/FormStyle";
import { Button, Dialog, DialogTitle, DialogContent, Grid } from "@material-ui/core";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import commonConstants from "../../../../Common/CommonConstants";
import {vacationLang} from "../../../../Common/Languages";

const VacationProfileForm = props => {
  const classes = useStyles()
  const [formFields, setFormFields] = useState();
  const [alertOpen, setAlertOpen] = useState(false);
  const [obj, setObj] = useState();
  const [error, setError] = useState({});
  const [makeCopy, setMakeCopy] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { requiredError, blankError } = commonConstants.error;

  const lang = localStorage.getItem("languages");

  useEffect(() => {
      setFormFields([
        { 
          id: "name", 
          label: vacationLang.NAME[lang] + " *", 
          type: "text", 
        },
        {
          id: "max_vacations",
          label: vacationLang.MAXVACATIONS[lang] + " *",
          type: "text", 
        },
        {
          id: "max_sick_days",
          label: vacationLang.MAXSICKDAYS[lang] + " *",
          type: "text", 
        },
        {
          id: "max_personal_days",
          label: vacationLang.MAXPERSONALDAYS[lang] + " *",
          type: "text", 
        },
        {
          id: "max_moving_days",
          label: vacationLang.MAXMOVINGDAYS[lang] + " *",
          type: "text",
        },
      ]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang]);
  // Note: lang is from localStorage and won't trigger re-renders,
  // but we include it to ensure fresh data if language changes

  const put = () => {
    http.Put(
      `hr_vacation_profiles/${obj.id}`,
      obj,
      (object) => { props.handleObjectSubmit() },
      (status, error) => {
        if (error["non_field_errors"]) {
          alert(vacationLang.helper[lang]);
        }
      }
    );
  }

  const onSubmit = () => {
    http.Post(
      `hr_vacation_profiles`,
      obj,
      (object) => { props.handleObjectSubmit() },
      (status, error) => {
        setError(error);
        setIsSubmitted(false);
      }
    )
  } 

  const handleSave = () => {
    setAlertOpen(false);
    put();
  }

  const handleCopy = () => {
    setMakeCopy(true);
  }

  const onDisagree = () => {
    setAlertOpen(false);
    setMakeCopy(false);
  }

  const onChange = (e) => {
    setObj({...obj, [e.target.name]: e.target.value});
    setIsSubmitted(false);
    setError({...error, [e.target.name]: false, non_field_errors: false});
  }

  return(
    <>
      {obj && (
        <Dialog
          open={alertOpen && makeCopy && Boolean(obj)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onClose={onDisagree}
        >
          <DialogTitle id="alert-dialog-title">{vacationLang.Enteranewname[lang]}:</DialogTitle>
          <DialogContent>
            <ValidatorForm onSubmit={onSubmit}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={3} align="right">
									<div style={{ fontWeight: 520 }}>
										<span className={classes.title}>{vacationLang.NAME[lang]} *</span>
									</div>
								</Grid>
                <Grid item xs={9}>
                  <TextValidator
                    id="name"
                    fullWidth
                    variant="outlined"
                    margin="dense"
                    name="name"
                    value={obj.name || ""}
                    onChange={onChange}
                    inputProps={{ maxLength: 255 }}
                    validators={["required", "trim"]}
                    errorMessages={[requiredError, blankError]}
                    error={Boolean(error.name)}
                    helperText={
                      (error.name && error.name[0]) || (
                       error.non_field_errors && <span className={classes.error}>{vacationLang.helper2[lang]}</span>
                    )}
                  />
                </Grid>
              </Grid>
              <div className={classes.footer}>
                <div className={classes.outlinedButtonContainer}>
                  <Button
                    variant="outlined"
                    margin="dense"
                    size="small"  
                    className={classes.outlinedButton}
                    onClick={onDisagree}
                  >
                    {vacationLang.Cancel[lang]}
                </Button>
                  <Button
                    variant="outlined"
                    margin="dense"
                    size="small"
                    className={classes.filledButton}
                    type="submit"
                    disabled={isSubmitted}
                  >
                    {vacationLang.Save[lang]}
                  </Button>
                </div>
              </div>
            </ValidatorForm>
          </DialogContent>
        </Dialog>
      )}
      <AlertDialog
          open={alertOpen && !makeCopy}
          primaryMessage={vacationLang.helper3[lang]}
          secondaryMessage={vacationLang.helper4[lang]}
          onSave={handleSave}
          onCopy={handleCopy}
          onDisagree={onDisagree}
          isVacationProfileEdit
        />
      {formFields && 
      <ObjectForm 
        {...props} 
        url={`hr_vacation_profiles`} 
        formName={vacationLang.VacationProfile[lang]} 
        formFields={formFields} 
        object={{...props.object, tenant: props.user.tenant}}
        setAlertOpen={props.objectId ? setAlertOpen : null}
        setObj={setObj}
      />}
    </>
  );
};

export default VacationProfileForm;
